import {Findings as FindingsView} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Suspense} from 'react'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {usePullRequestBasePath} from '../../stores/layout-selectors'
import styles from './Findings.module.css'
import {CollapsiblePanel} from './CollapsiblePanel'

/** Findings section — suspends while deferred data loads */
export function Findings() {
  return (
    <CollapsiblePanel heading="Findings">
      <ErrorBoundary boundaryName="Findings" fallback={null}>
        <Suspense fallback={null}>
          <FindingsContent />
        </Suspense>
      </ErrorBoundary>
    </CollapsiblePanel>
  )
}

function FindingsContent() {
  const basePath = usePullRequestBasePath()
  const {
    data: {aliveChannels},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  return (
    <div className={styles.list}>
      <FindingsView pullRequestBasePath={basePath} aliveChannel={aliveChannels.pullRequest} variant="overview" />
    </div>
  )
}
